import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function Yahoo({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Yahoo"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2196_48290)">
        <path
          clipRule="evenodd"
          d="M14.8351 9.99906C14.8351 5.92408 11.6226 2.8126 7.41756 2.8126C3.21248 2.8126 0 5.92408 0 9.99906C0 14.0739 3.21248 17.1867 7.41756 17.1867C11.6226 17.1867 14.8351 14.0741 14.8351 9.99906ZM7.16956 6.78898C7.13425 7.03717 7.11606 7.28527 7.09906 7.53467C6.58331 7.56987 6.06877 7.60517 5.55418 7.65867C5.94354 8.13658 6.33288 8.61869 6.72219 9.10081C7.11375 9.58569 7.50531 10.0706 7.89694 10.5512C8.27731 10.2237 8.658 9.90069 9.03863 9.57769C9.42125 9.253 9.80394 8.92825 10.1863 8.59897C10.1517 8.59789 10.1171 8.59682 10.0825 8.59575C9.53188 8.57869 8.98019 8.56159 8.42975 8.52847V7.79977C9.93256 7.76627 11.42 7.74916 12.9213 7.7319L13.1493 7.72927V8.59907C12.6051 8.65201 12.0778 8.68704 11.5518 8.72197L11.5353 8.72307C10.5061 9.64637 9.47575 10.5682 8.42975 11.4916C8.42044 11.8542 8.41144 12.2213 8.40244 12.5881C8.39381 12.9399 8.38519 13.2914 8.37625 13.6386C8.41125 13.6396 8.44625 13.6406 8.48125 13.6417C9.04956 13.6587 9.61788 13.6759 10.1863 13.7102V14.3658H4.61388V13.7102C4.91633 13.6834 5.21876 13.6611 5.52117 13.6389C5.82208 13.6167 6.12298 13.5946 6.42388 13.5679V11.5621C5.34128 10.2497 4.27698 8.95419 3.21269 7.65867C2.92789 7.64103 2.64737 7.61876 2.36701 7.5965C2.0881 7.57436 1.80935 7.55223 1.52669 7.53467V6.78898H7.16956Z"
          fillRule="evenodd"
        />
        <path d="M19.9999 3.52406C18.5622 3.45236 17.1426 3.38186 15.7232 3.31006C15.6514 6.70014 15.5809 10.1073 15.5104 13.4973C16.1841 13.5679 16.8764 13.6385 17.5501 13.7102C18.3664 10.3032 19.1836 6.91304 19.9999 3.52406ZM15.3144 17.1696H17.7631V15.1296C16.8764 15.058 15.9896 14.9874 15.1016 14.9169C15.1721 15.6795 15.2439 16.4252 15.3144 17.1696Z" />
      </g>
      <defs>
        <clipPath id="clip0_2196_48290">
          <rect height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}
